import { render, staticRenderFns } from "./AppToggle.vue?vue&type=template&id=51f97c94&scoped=true"
import script from "./AppToggle.vue?vue&type=script&lang=js"
export * from "./AppToggle.vue?vue&type=script&lang=js"
import style0 from "./AppToggle.vue?vue&type=style&index=0&id=51f97c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f97c94",
  null
  
)

export default component.exports